import {
	type BuildingSavingsDetailDataDTO,
	ClientPortfolioPaymentFrequencyEnum,
	type PortfolioDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { BUILDING_SAVINGS_EDIT_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/buildingSavingsFormDefaults";
import type { BuildingSavingsEditFormInput } from "web_myplann/Portfolio/Forms/BuildingSavingsForm/buildingSavingsFormSchema";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";

export const mapPortfolioToBuildingSavingsForm = (
	portfolio: PortfolioDetailResponseDTO,
): BuildingSavingsEditFormInput => {
	const data = portfolio.data as BuildingSavingsDetailDataDTO | undefined;
	return {
		name: portfolio.name ?? DEFAULTS.name,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
		payment: data?.payment ?? DEFAULTS.payment,
		paymentFrequency:
			data?.paymentFrequency &&
			data.paymentFrequency !== ClientPortfolioPaymentFrequencyEnum.None
				? data.paymentFrequency
				: DEFAULTS.paymentFrequency,
		appreciation: data?.appreciation ?? DEFAULTS.appreciation,
		targetAmount: data?.targetAmount ?? DEFAULTS.targetAmount,
	};
};
